export default __webpack_public_path__ + "static/media/no.f170b2f3.svg";